import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { COLORS } from '../COLORS';

export const WhiteAppBar = styled(AppBar)({
    backgroundColor: COLORS.whiteColor,
    boxShadow: 'none',
});
export const DrawerContent = styled(Box)({
    width: '40vh',
    height: '100vh',
    backgroundColor:COLORS.whiteColor,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '20px',
    color: 'black',
});